<header>
  <img src="logo_te.svg" width="60" title="TotalEnergies" alt="TotalEnergies" class="logo me-4 pointer"
    routerLink="/home" />
  <div class="header-right">
    <div class="header-top">
      <div class="me-auto header-title">
        <div class="app-name me-3">
          {{'general.app_name' | translate}}
        </div>
      </div>
      @if (user()) {
        <ng-container class="header-badge-container">
          <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu">
            <div class="d-flex align-items-center">
              <span class="display-name" matPrefix>{{ getUserDisplayName() }}</span>
              <mat-icon color="primary" class="ms-1">keyboard_arrow_down</mat-icon>
            </div>
          </button>
          <mat-menu #userMenu="matMenu" [overlapTrigger]="false" role="menu"
            attr.aria-label="{{ 'header.aria.menu_logout' | translate }}">
            @if(getCurrentAffiliateName()) {
              <div mat-menu-item>
                <mat-icon>home_pin</mat-icon>
                <div class="affiliate-name">
                  {{ getCurrentAffiliateName() }}
                </div>
              </div>
            }
            @if(getCurrentRole()) {
              <div mat-menu-item>
                <mat-icon>badge</mat-icon>
                <div class="affiliate-name">
                  {{ getCurrentRole() }}

                  @if(getDefaultLocationName()) {
                    <div class="default-location">
                      {{'@\u00A0' + getDefaultLocationName() }}
                    </div>
                  }
                </div>
              </div>
            }
            <button mat-menu-item [routerLink]="logoutRoute" (click)="logOut()">
              {{ 'general.main_menu.logout' | translate }}
            </button>
          </mat-menu>
        </ng-container>
      }
    </div>

    <div class="d-flex" [class.justify-content-end]="!isUserLoggedIn()"
      [class.justify-content-between]="isUserLoggedIn()">
      @if (isUserLoggedIn()) {
        <mps-app-navigation></mps-app-navigation>
      }

      <div class="right-menu-items d-flex align-items-center">
        @if (isUserLoggedIn()) {
          @if (canChangeAffiliate()) {
            <div class="affiliate-chooser me-2">
              <button mat-button [matMenuTriggerFor]="menu" aria-label="Select an affiliate">
                <div class="d-flex align-items-center">
                  <mat-icon color="primary" class="material-symbols-outlined"
                  fontSet="material-symbols">home_pin</mat-icon>
                  <div class="typo-gray ms-1">{{ getCurrentAffiliateName() }}</div>
                  <mat-icon color="primary" class="ms-1" matSuffix>keyboard_arrow_down</mat-icon>
                </div>
              </button>
              <mat-menu #menu="matMenu">
                @for (affiliate of affiliates; track affiliate) {
                  <button mat-menu-item
                    (click)="changeAffiliate(affiliate.id)">
                    <div class="affiliate-line">
                      <div class="checked">
                        @if (isCurrentAffiliate(affiliate.id)) {
                          <mat-icon color="primary">check</mat-icon>
                        }
                      </div>
                      <div class="affiliate-name"> {{ affiliate.name }} </div>
                    </div>
                  </button>
                }
              </mat-menu>
            </div>
          }
        }
        <!-- // TODO: No language switcher for now
        <button mat-button [matMenuTriggerFor]="langMenu" class="lang-menu">
          <div class="d-flex align-items-center">
            <mat-icon color="primary" class="me-1" matPrefix>language</mat-icon>
            <div class="typo-gray">{{ getCurrentLangLabel() }}</div>
            <mat-icon color="primary" class="ms-1" matSuffix>keyboard_arrow_down</mat-icon>
          </div>
        </button>
        <mat-menu #langMenu="matMenu" [overlapTrigger]="false" role="menu"
          attr.aria-label="{{ 'header.aria.change_language' | translate }}">
          <button mat-menu-item *ngFor="let lang of translateService.getLangs()"
            (click)="switchLanguage(lang)">
            {{ getLangLabel(lang) }}
          </button>
        </mat-menu>
        -->
      </div>
    </div>

    <nav (click)="nav?.toggle()" role="navigation" (keyup)="nav?.toggle()" class="burger-container" role="menu">
      <mat-icon class="burger menu" [ngClass]="{'active': !nav?.opened}">menu</mat-icon>
      <mat-icon class="burger close" [ngClass]="{'active': nav?.opened}">close</mat-icon>
    </nav>
  </div>
</header>
